import { FormControlLabel } from '@material-ui/core'
import React from 'react'

export const IUIFormControlLabel = (props) => {
  return <FormControlLabel {...props}>{props.children}</FormControlLabel>
}
